/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForNextWeekDto } from '../models/IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForNextWeekDto';
import type { IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForThisMonthDto } from '../models/IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForThisMonthDto';
import type { IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForThisWeekDto } from '../models/IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForThisWeekDto';
import type { IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForTodayDto } from '../models/IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForTodayDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LeaveDetailsService {

    /**
     * @returns IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForNextWeekDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppLeaveDetailsStaffOnLeaveForNextWeek(): CancelablePromise<Array<IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForNextWeekDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/leave-details/staff-on-leave-for-next-week',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @returns IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForThisMonthDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppLeaveDetailsStaffOnLeaveForThisMonth(): CancelablePromise<Array<IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForThisMonthDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/leave-details/staff-on-leave-for-this-month',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @returns IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForThisWeekDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppLeaveDetailsStaffOnLeaveForThisWeek(): CancelablePromise<Array<IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForThisWeekDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/leave-details/staff-on-leave-for-this-week',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @returns IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForTodayDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppLeaveDetailsStaffOnLeaveForToday(): CancelablePromise<Array<IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForTodayDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/leave-details/staff-on-leave-for-today',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

}
